/**
 * 诊断相关文案配置
 */
export default {
  // 诊断名称
  name: 'Admission Test',
  gradePlaceholder: "Child's grade in fall",
  onLineText: 'Online Evaluation  Now',
}
